import { render, staticRenderFns } from "./PosRadioGroup.vue?vue&type=template&id=16fda9eb&"
import script from "./PosRadioGroup.vue?vue&type=script&lang=js&"
export * from "./PosRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports